export function deepCopy<T>(inObject: T) {
  let value: any;
  let key: any;

  if (typeof inObject !== "object" || inObject === null) {
    return inObject;
  }

  const outObject: any = Array.isArray(inObject) ? [] : {};
  for (key in inObject) {
    value = (inObject as any)[key];
    outObject[key] = deepCopy(value);
  }

  return outObject as T;
}

export function isSameObject(obj1: any, obj2: any) {
  //NOSONAR
  for (const p in obj1) {
    //Check property exists on both objects
    if (
      Object.prototype.hasOwnProperty.call(obj1, p) !==
      Object.prototype.hasOwnProperty.call(obj2, p)
    )
      return false;

    if (obj1[p] === null && obj2[p] === null) {
      continue;
    } else {
      if (
        (obj1[p] === null && obj2[p] !== null) ||
        (obj1[p] !== null && obj2[p] === null)
      ) {
        return false;
      }
    }

    switch (typeof obj1[p]) {
      //Deep compare objects
      case "object":
        if (!isSameObject(obj1[p], obj2[p])) return false;
        break;
      //Compare function code
      case "function":
        if (
          typeof obj2[p] === "undefined" ||
          (p !== "compare" && obj1[p].toString() !== obj2[p].toString())
        )
          return false;
        break;
      //Compare values
      default:
        if (obj1[p] !== obj2[p]) return false;
    }
  }
  for (const p in obj2) {
    if (
      Object.prototype.hasOwnProperty.call(obj1, p) !==
      Object.prototype.hasOwnProperty.call(obj2, p)
    )
      return false;
  }
  //Check object 2 for any extra properties
  for (const p in obj2) {
    if (typeof obj1[p] === "undefined") return false;
  }
  return true;
}

export function isSubsetEqual(obj1: any, obj2: any): boolean {
  for (const key in obj2) {
    if (!Object.prototype.hasOwnProperty.call(obj1, key)) return false;

    const val1 = obj1[key];
    const val2 = obj2[key];

    if (key == "nbtTotal") continue;
    if (val1 == val2) continue;

    // Handle nulls
    if (val1 === null && val2 === null) {
      continue;
    } else {
      if (
        (val1 === null && val2 !== null) ||
        (val1 !== null && val2 === null)
      ) {
        return false;
      }
    }

    // Handle objects
    if (typeof val1 === "object" && typeof val2 === "object") {
      if (!isSubsetEqual(val1, val2)) return false;
    } else if (typeof val1 === "function" && typeof val2 === "function") {
      if (val1.toString() !== val2.toString()) return false;
    } else {
      // Primitive value comparison
      if (val1 != val2) return false;
    }
  }

  if (
    Object.prototype.hasOwnProperty.call(obj1, "resetExpertMode") &&
    !Object.prototype.hasOwnProperty.call(obj2, "resetExpertMode")
  ) {
    return false;
  }

  return true;
}

export function isEmpty(obj: any) {
  for (const prop in obj) {
    if (Object.hasOwn(obj, prop)) {
      return false;
    }
  }

  return true;
}
